"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLUENT_CDN_BASE_URL = void 0;
exports.FLUENT_CDN_BASE_URL = 'https://res.cdn.office.net/files/fabric-cdn-prod_20230307.001';
//# sourceMappingURL=cdn.js.map